
import mixins from '@mods/store/template';
import { HttpPerMenu, HttpMenuList, HttpSystemList, HttpOrgRolePerMenu, HttpAllAttachmentModel,HttpAllAttachmentType} from "@/service/ucadm";
const list = [{
    name: 'authmenu',//权限菜单
    ajaxRequest: HttpMenuList,
}, {
    name: 'permenu',//允许的权限菜单
    ajaxRequest: HttpPerMenu,
}, {
    name: 'sysList',//所有组织
    ajaxRequest: HttpSystemList,
    formData: {
        rows: 1000,
        page: 1,
        sidx: "id",
        sord: "desc"
    },
    interceptResponse: res => {
        const content = res.data.content || [];
        return content.map(item => {
            return {
                value: item.id,
                label: item.name
            }
        })
    }
}, {
    name: 'reportsqlList',//数据报表权限列表
    ajaxRequest: HttpPerMenu,
}, {
    name: 'orgRolePermenu',//允许的组织角色权限菜单
    ajaxRequest: HttpOrgRolePerMenu,
}, {
    name: 'attachmentModels',//允许的组织角色权限菜单
    ajaxRequest: HttpAllAttachmentModel,
    interceptResponse: res => {
        res = res || [];
        return res.map(item => {
            return {
                value: item.id,
                label: item.title,
                attach: {
                    code: item.code,
                }
            }
        })
    }
},{
    name: 'attachmentTypes',//允许的组织角色权限菜单
    ajaxRequest: HttpAllAttachmentType,
    interceptResponse: res => {
        res = res || [];
        return res.map(item => {
            return {
                value: item.id,
                label: item.title,
                attach: {
                    code: item.code,
                }
            }
        })
    }
}]
export default mixins(list)